import { FunctionComponent } from "react";

import { PrimaryButton, SecondaryButton } from "@ppb/the-wall-web";
import { Alerts } from "../../../Alerts/Alerts.web";

import { PlacedBetCard } from "../PlacedBetCard/PlacedBetCard.web";
import { ExchangeUnmatchedCardViewModel } from "./ExchangeUnmatchedCard.types";

import styles from "./ExchangeUnmatchedCard.web.css";
import { i18n } from "../../../../helpers/i18n";

export const ExchangeUnmatchedCard: FunctionComponent<ExchangeUnmatchedCardViewModel> = ({
  type,
  price,
  stake,
  stakeDetail,
  liability,
  profit,
  bonus,
  hasFreeBets,
  notifications,
  shouldDisplayBetWithMatchMe,
  matchMeSecondaryLabel,
  labels,
  onBetWithMatchMe,
  onCancel,
  onEdit,
}) => {
  const hasActions = !!onCancel || !!onEdit;
  const hasBetWithMatchMeAction = !!onBetWithMatchMe;
  const isFullMode = !!onCancel && !!onEdit;
  const isCancelMode = !isFullMode && !!onCancel;

  return (
    <PlacedBetCard
      type={type}
      price={price}
      stake={stake}
      stakeDetail={stakeDetail}
      liability={liability}
      profit={profit}
      bonus={bonus}
      hasFreeBets={hasFreeBets}
      labels={labels}
    >
      <div className={styles.notifications}>
        <Alerts alerts={notifications} />
      </div>
      {hasActions && (
        <>
          {isFullMode && shouldDisplayBetWithMatchMe && hasBetWithMatchMeAction && (
            <div className={styles.matchMeButton}>
              <PrimaryButton
                label={i18n({ key: "I18N.BETSLIP.BET_BUTTON.BET_WITH_MATCH_ME" })}
                secondaryLabel={matchMeSecondaryLabel}
                onTap={onBetWithMatchMe}
              />
            </div>
          )}
          <div className={styles.actions}>
            {(isCancelMode || isFullMode) && (
              <div className={styles.actionItem}>
                <SecondaryButton label={labels.cancel} onTap={onCancel} />
              </div>
            )}
            {isFullMode && (
              <div className={styles.actionItem} data-test-id="placed-bet-card-edit">
                {shouldDisplayBetWithMatchMe ? (
                  <SecondaryButton label={labels.confirm} onTap={onEdit} />
                ) : (
                  <PrimaryButton label={labels.confirm} onTap={onEdit} />
                )}
              </div>
            )}
          </div>
        </>
      )}
    </PlacedBetCard>
  );
};
